import React, { useRef } from "react";
import SvgGeoloc from "../../_svg/Geolocalisation";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const ref = useRef();
  const { t } = props
  const content = {
    title: t('applications.saphir.geolocation'),
    description: t('applications.saphir.geolocation.description')
  }
  return (
              <div className={"svg-container"} id={"svg-geoloc-saphir"} itemScope itemType="https://schema.org/WebPage">
                <div>
                  <SvgGeoloc fill={"#b77830"}/>
                <h3 itemProp="alternativeHeadline">{content.title}</h3>
                  <span itemProp="description">
                    {content.description}
                  </span>
                </div>
              </div>
  );
};

const tr = withTranslation()(App);
export default tr;
